"use client";

import Campus from "../types/Campus";
import memoizeAsync from "../util/memoizeAsync";
import {NEXT_SITE_URL} from "../util/urlUtils";

/**
 * Fetch campus information for the given campusId. Callable from the client.
 *
 * Use the cookie campus if no campus is specified.
 *
 * @param campusId The campusId to fetch the campusId for
 * @returns The corresponding Campus object if it exists, or null if it doesn't.
 */
export const fetchCampusClient = async (campusId?: string) => {
	let campusFetchUrl = `${NEXT_SITE_URL}/get-campus-info`;
	if (campusId) {
		const params = new URLSearchParams({campusId});
		campusFetchUrl += `?${params.toString()}`;
	}

	try {
		const campusResponse = await fetch(campusFetchUrl);
		const campus = await campusResponse.json();
		return campus as Campus | null;
	} catch (err) {
		console.warn("An error occurred while fetching campus info.", err);
		return null;
	}
};

/**
 * Memoized version of fetchCampus for use on the frontend.
 *
 * We need to do this in a separate file because fetchCampus is a server action,
 * and so we can't memoize it in the module where it's defined.
 */
const fetchCampusMemoized = memoizeAsync(fetchCampusClient);

export default fetchCampusMemoized;
